import * as clsApi from "./classroomApi";
import { StudentScreenshotStatus } from "@/stores/v2/studentStateStore";
import { useUserSessionStore } from "stores/v2/userSessionStore";

interface ScreenshotReliabilityReport {
	classroomSourceName: string;
	classroomStableId: string;
	studentStableId: string;
	studentUsername: string;
	classStartTime: number;
	// All classroom session types are now "manual". This is a relic from when scheduled class sessions were different.
	classSessionType: "MANUAL" | "SCHEDULED";
	classLoadedTime: number;
	remediationType: StudentScreenshotStatus;
	totalStudentsInClass: number;
	totalStudentsWithScreenshots: number;
	studentsNotShowingScreenshots: string[];
}

export async function reportScreenshotReliability(body: ScreenshotReliabilityReport): Promise<void> {
	try {
		const applianceId = useUserSessionStore.getState().getActiveDevice() as string;
		return await clsApi.Post2(`v1/appliances/${applianceId}/screenshot/report`, body);
	} catch (error) {
		console.error("Error reporting screenshot reliability:", error);
		throw error;
	}
}
